import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "@/components/ui/carousel";
import React from "react";
import { MeetOurTeam as IMeetOurTeam } from "@/types/about-us-page";
import { Skeleton } from "@/components/ui/skeleton";

const MeetOurTeam: React.FC<{
  meetOurTeam?: IMeetOurTeam[];
  isLoading: boolean;
}> = ({ meetOurTeam, isLoading }) => {
  return (
    <Carousel className="mt-6 w-full">
      <CarouselContent>
        {isLoading
          ? Array.from({ length: 10 }).map((_, i) => (
              <CarouselItem key={i}>
                <Skeleton className="flex h-80 w-[262px] flex-col items-center overflow-hidden rounded-2xl bg-[#E2DDD7] md:h-[394px] md:w-80" />
              </CarouselItem>
            ))
          : meetOurTeam?.map((member) => (
              <CarouselItem key={member.name}>
                <div className="flex h-80 w-[262px] flex-col items-center justify-between overflow-hidden rounded-2xl bg-[#E2DDD7] md:h-[394px] md:w-80">
                  <img
                    src={member.image?.large_url}
                    alt={member.name}
                    className="h-[244px] w-full object-cover md:h-[296px]"
                    loading="lazy"
                  />
                  <div className="w-full p-6 text-[#232329]">
                    <h6 className="text-base font-semibold md:text-lg">{member.name}</h6>
                    <p className="text-sm md:text-base">{member.title}</p>
                  </div>
                </div>
              </CarouselItem>
            ))}
      </CarouselContent>
      <CarouselPrevious className="hidden md:flex" />
      <CarouselNext className="hidden md:flex" />
    </Carousel>
  );
};

export default MeetOurTeam;
